import type { WebsiteKind } from '@/api/schema';

export const WEBSITE_SECTIONS = [
  {
    kind: 'press',
    title: 'Press Releases',
    item: 'press release',
    path: '/website/press-releases',
    publicPath: '/press-releases/',
  },
  {
    kind: 'blog',
    title: 'Blog',
    item: 'blog post',
    path: '/website/blog',
    publicPath: '/blog/',
  },
  {
    kind: 'event',
    title: 'Events',
    item: 'event',
    path: '/website/events',
    publicPath: '/events/',
  },
  { kind: 'faq', title: 'FAQ', item: 'question', path: '/website/faq', publicPath: '/faq/' },
] as const satisfies readonly {
  kind: WebsiteKind;
  title: string;
  item: string;
  path: string;
  publicPath: string;
}[];

export type WebsiteSectionConfig = (typeof WEBSITE_SECTIONS)[number];
